import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import './assets/css/adam.css';

import UnderConstruction from './pages/under-construction';
import Start from './pages/start';
import About from './pages/about';
import Brands from './pages/brands';
import Bridal from './pages/bridal';
import Contact from './pages/contact';

class App extends Component {

    render() {
        return (
            <div className="app">
                <Switch>
                    <Route path='/' exact component={Start}/>
                    <Route path='/start' component={Start}/>
                    <Route path='/about' component={About}/>
                    <Route path='/brands/:brand?' component={Brands}/>
                    <Route path='/bridal/:brand?' component={Bridal}/>
                    <Route path='/contact' component={Contact} />
                </Switch>
            </div>
        );
    }
}

export default App;
